import { Angelou, Bowie, Dickenson, Fitzgerald, Head, Hemmingway, Jobs, King, Lee, Lincoln } from "constants/Accounts";

const QUOTES = [
  {
    message: "The best way to predict your future is to create it.",
    signature: "0x97eaef4d26a3cc71a800f374aec08a955a286f645214137c0889b6093592eb7a238ca6cfed92deffc79732082a1470b7b4f030d1fe30e7ff961a4bcedd3c1b0d1b",
    possibleSigners: [Jobs, Lincoln]
  },
  {
    message: "He who is devoid of the power to forgive is devoid of the power to love.",
    signature: "0x8a478b8fffec1dd4b6f7af3e952fa36faa8e71836de4234a80abf64ff656740a3ae556d9dad048df90a9a94f6a7e89dfacf253206ec9da2218462d0d6113f1861c",
    possibleSigners: [King, Dickenson]
  },
  {
    message: "You don't write because you want to say something, you write because you have something to say.",
    signature: "0x363e98361373feb4c0a38d9ccde6476d635044733d1f6403ff03104f82063400483d88ba7ce36631d2089d4f737e55052c4da8af8114413e64f0d19534863c0e1b",
    possibleSigners: [Fitzgerald, Hemmingway]
  },
  {
    message: "Lightning makes no sound until it strikes.",
    signature: "0x865fd17cfda3aa8ac15ae95c2244e1da9963fa5fe80181b041e10a1c23132f921a00c6e200bd53a7356f12f43022c697015b4ae3c487f4f42f125568cbc4273f1c",
    possibleSigners: [Head, King]
  },
  {
    message: "Courage is grace under pressure.",
    signature: "0x430f96743f335abfff6622f11d1a006615a2e4aa593cf5529a27632eb0dc8178279d54b58ad6ee9df6a3f49b9aba64f23d60075bdeab860925d91f7875a91f501b",
    possibleSigners: [Hemmingway, Dickenson]
  },
  {
    message: "You never really understand a person until you consider things from his point of view.",
    signature: "0x877c1d31bebe8d531c6d689feccb028e98a2070a30ee2f4d8641923ab26c54807298207ddb5470ebe32c05be817d178b58c4f34ccfc2fcc4bcc6f0247695e91e1c",
    possibleSigners: [King, Lee]
  },
  {
    message: "Innovation distinguishes between a leader and a follower.",
    signature: "0xdf76e090133cce0f9cd28a93e9c26ac60d4831f06b1e56bcd07891b147a9602a1ae0bb91f9b06d469a0011c3c6d6d5477462cd7f0caf58df6f8d1d27096e66f71b",
    possibleSigners: [Head, Jobs]
  },
  {
    message: "You would think that a rock star being married to a supermodel would be one of the greatest things in the world. It is.",
    signature: "0x331f364d0534732eb865b80e98ea28f528a2a01ec7c1f4e70ba82a83668956b6284370415ae1c159559c13884f26079c8f2a7b0ca23fe79ea67e28709664844b1c",
    possibleSigners: [Angelou, Bowie]
  },
  {
    message: "That it will never come again is what makes life so sweet.",
    signature: "0x08a370f65bd245a92f59012d0a232dde025c8761022fc6e57cbab2c93450ae9d57684177cb3a0b9c81287cdc476932bfdeb5fecf1f629da7851a6dbd4ccfba0a1b",
    possibleSigners: [Dickenson, Lincoln]
  },
  {
    message: "You can only become truly accomplished at something you love.",
    signature: "0x1e68dc823664b091d2106430f07e54bcdd2d046391f37e7cdaca41dee999d19e7eff2d138d5fc21decd98c5bd56c684e9bb543a2cc3be12589a10be3692ee5bf1b",
    possibleSigners: [Angelou, Jobs]
  },
  {
    message: "You can have anything you want in life if you dress for it.",
    signature: "0xa0bc785781521ebbde147cdfa88a3b8aef76a92f1a54dafb2329db6318fa1a3f225dca258347d6f159138dacac729b0b5b9cacedd0c009ba47c2107e144ea4fe1c",
    possibleSigners: [Fitzgerald, Head]
  },
  {
    message: "Until I feared I would lose it, I never loved to read. One does not love breathing.",
    signature: "0x06e03eb3e680093947253b715046a4e203800296677a3ab32edfb68dc8c8f3c23383904e55832e86f4c2ee113418e998795f75e57ed948eefd46f7d3aebcd8741c",
    possibleSigners: [Hemmingway, Lee]
  },
  {
    message: "You can’t use up creativity. The more you use, the more you have.",
    signature: "0xeef180e4c4fd3cba182cf2f295a2385e3a1d12570df06f93c561ad3859adb4805c9e2045cc03df7be942adb38f7535d7f090c30dee31120de15d695e906d2c061b",
    possibleSigners: [Bowie, Angelou]
  },
  {
    message: "No matter how much cats fight, there always seem to be plenty of kittens.",
    signature: "0x0a1b0e1a9dd3b500fb41ce65eea6a1e38c69d3a148017a04f853c5e8a8e112333cfd8bbd658125aadb0086664aa22ba717a70d788fd11593f8e1b2f7295703ad1b",
    possibleSigners: [Lincoln, Lee]
  },
  {
    message: "I don't know where I'm going from here, but I promise it won't be boring.",
    signature: "0xb5e31679721ccb169b35efebcb48c9d6d9863a988e7be5d15711c14e9a52df981d0180d3f828d1b3e7958cd79d2ee4476737aafd53c6c4dff48da6da1cfe4fca1c",
    possibleSigners: [Bowie, Fitzgerald]
  },
];

export default QUOTES;